import { useState, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import FJModalClose from '../../FJModalClose/FJModalClose';
import classNames from 'classnames';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton.jsx';
import DownloadIcon from '../../../../assets/svg/download.svg?react';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import EditIcon from '../../../../assets/svg/edit.svg?react';
import FJEditIcon from '../../../../assets/svg/ttv/edit-1.svg?react';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller.jsx';
import FJItem from './FJItem.jsx';
import FJPlayIcon from '../../../../assets/svg/play.svg?react';
import FJPauseIcon from '../../../../assets/svg/pause.svg?react';
import styles from './FJTextToSpeechModal.module.less';
import FJConstant from '../../../../constants/FJConstant.js';
import FJS3Config from '../../../../config/FJS3Config.js';
import FJUtil from '../../../../util/FJUtil.js';
import FJEvent from '../../../../store/FJEvent.js';
import { FJ_EVENT_TYPE } from '../../../../constants/FJEvenTypeConstant.js';
import useModalAdapatSize from '../../../../hooks/useModalAdapatSize.jsx';
import FJConfig from '../../../../config/FJConfig.js';

const FJTextToSpeechModal = props => {
    const { info = [], onClose, onDownload, onUseToFlexClip, onEdit } = props;
    const { list = [], createTime } = info;

    const [isPlay, setIsPlay] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [totalDuration, setTotalDuration] = useState(0);
    const _currentPlayId = useRef(null);
    const _isGlobalPlay = useRef(false);

    const useList = useMemo(() => {
        return list.map(item => {
            if (item.generationType === FJConstant.MICROSOFT) {
                return {
                    ...item,
                    audioUrl: FJS3Config.S3_SERVER_HOST + item.audioUrl,
                };
            } else if (
                item.generationType === FJConstant.CLONE_BY_SELF ||
                item.generationType === FJConstant.CLONE_BY_FLEX_CLIP
            ) {
                return {
                    ...item,
                    audioUrl: FJS3Config.S3_SERVER_HOST + FJConfig.resultAudioKey + item.audioUrl,
                };
            } else {
                return { ...item };
            }
        });
    }, [list]);

    const _onDownload = () => {
        onDownload(useList.map(item => item.audioUrl));
    };

    const _updateCurrentTime = time => {
        setCurrentTime(time);
    };

    const _onEnded = id => {
        setTotalDuration(0);
        _currentPlayId.current = null;
        if (_isGlobalPlay.current) {
            const findIndex = useList.findIndex(item => item.id === id);
            if (useList[findIndex + 1]) {
                _currentPlayId.current = useList[findIndex + 1].id;
                _globalChangePlay();
            } else {
                _isGlobalPlay.current = false;
            }
        }
    };

    const _updateIsPlay = (bool, id) => {
        setIsPlay(bool);
        if (bool) {
            _currentPlayId.current = id;

            if (_currentPlayId.current && _currentPlayId.current === id) {
                setTotalDuration(useList.find(item => item.id === id)?.audioDuration);
            }
        }
    };

    const _globalChangePlay = () => {
        _isGlobalPlay.current = true;
        if (!_currentPlayId.current) {
            _currentPlayId.current = useList[0].id;
        }
        FJEvent.dispatch(FJ_EVENT_TYPE.TTV_CHANGE_PLAY, _currentPlayId.current);
    };

    const _onPlayClick = id => {
        _isGlobalPlay.current = false;
        if (_currentPlayId.current !== id) {
            FJEvent.dispatch(FJ_EVENT_TYPE.TTV_STOP_PLAY, _currentPlayId.current);
        }
        _currentPlayId.current = id;
    };

    const { width, height } = useModalAdapatSize({ maxWidth: 1336, maxHeight: 920, minWidth: 814, minHeight: 560 });
    return (
        <div className={styles.box} style={{ width: width, height: height }}>
            <FJModalClose onClick={onClose} />
            <div className={styles.content}>
                <div className={styles.left}>
                    <FJVerticalScroller className={styles.scroll}>
                        <div className={styles.inner}>
                            {useList.map((item, index) => (
                                <FJItem
                                    key={item.id}
                                    index={index + 1}
                                    info={item}
                                    updateIsPlay={bool => {
                                        _updateIsPlay(bool, item.id);
                                    }}
                                    updateCurrentTime={time => {
                                        _updateCurrentTime(time);
                                    }}
                                    onEnded={() => {
                                        _onEnded(item.id);
                                    }}
                                    onPlayClick={() => {
                                        _onPlayClick(item.id);
                                        // setTotalDuration(item.audioDuration);
                                    }}
                                />
                            ))}
                        </div>
                    </FJVerticalScroller>
                    <div className={styles.bottom}>
                        <div className={styles.control} onClick={_globalChangePlay}>
                            {isPlay ? <FJPauseIcon /> : <FJPlayIcon />}
                        </div>
                        <span className={styles.time}>{FJUtil.formatTime(currentTime, false, 2)}</span>
                        <span className={classNames(styles.time, styles.opacity_45)}>
                            / {FJUtil.formatTime(totalDuration, false, 2)}
                        </span>
                    </div>
                </div>
                <div className={styles.right}>
                    <FJButton
                        className={classNames(styles.btn, styles.margin_bottom_10)}
                        textClassName={styles.btn_text}
                        icon={<DownloadIcon />}
                        text={FJLocalStore._('download')}
                        onClick={_onDownload}
                        type={FJButtonType.GRADIENT}
                        isLoading={false}
                        strokeColor={'#FFF'}
                    />
                    <FJButton
                        className={classNames(styles.btn, styles.margin_bottom_10)}
                        textClassName={styles.btn_text}
                        icon={<FJEditIcon />}
                        text={FJLocalStore._('edit-speech')}
                        onClick={onEdit}
                        type={FJButtonType.DEFAULT}
                        isLoading={false}
                    />
                    <FJButton
                        className={styles.btn}
                        textClassName={styles.btn_text}
                        icon={<EditIcon />}
                        text={FJLocalStore._('use-in-flex-clip')}
                        onClick={onUseToFlexClip}
                        type={FJButtonType.DEFAULT}
                        isLoading={false}
                    />
                    <div className={styles.date}>
                        {FJLocalStore._('date-desc')}
                        <span>{createTime}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};
FJTextToSpeechModal.propTypes = {
    info: PropTypes.object,
    onClose: PropTypes.func,
    onDownload: PropTypes.func,
    onUseToFlexClip: PropTypes.func,
    onEdit: PropTypes.func,
};
export default FJTextToSpeechModal;
